import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-[#C9A961] shadow-2xl">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold text-[#0A2540] mb-2">
              {t('cookie.title')}
            </h3>
            <p className="text-sm text-gray-700">
              {t('cookie.message')}{' '}
              <a href="/datenschutz" className="text-[#C9A961] font-semibold hover:underline">
                {t('cookie.link')}
              </a>.
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <Button
              onClick={declineCookies}
              variant="outline"
              className="border-gray-300"
            >
              {t('cookie.decline')}
            </Button>
            <Button
              onClick={acceptCookies}
              className="bg-gradient-to-r from-[#C9A961] to-[#D4AF37] hover:from-[#D4AF37] hover:to-[#E5C158]"
            >
              {t('cookie.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
